import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { PagesGuard } from './auth/guards/pages.guard';
import { EnforcementGuard } from './auth/guards/enforcement.guard';
import { LockedComponent } from './locked/locked.component';
import { ProfileCompletionGuard } from './auth/guards/profile-completion.guard';
import { CompleteProfileComponent } from './complete-profile/complete-profile.component';

export const routes: Routes = [
  {
    path: 'pages',
    loadChildren: () => import('./pages/pages.module').then((m) => m.PagesModule),
    // Date of birth first (quick, once), then the lock check.
    canActivate: [PagesGuard, ProfileCompletionGuard, EnforcementGuard],
    canActivateChild: [ProfileCompletionGuard, EnforcementGuard]
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then((m) => m.NgxAuthModule)
  },
  { path: 'locked', component: LockedComponent },
  { path: 'complete-profile', component: CompleteProfileComponent },
  { path: '', redirectTo: 'pages', pathMatch: 'full' },
  { path: '**', redirectTo: 'pages' }
];

const config: ExtraOptions = {
  useHash: false
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
